module.exports = __webpack_public_path__ + "static/media/whistle.fcbfb9e8.svg";